import { render } from "./index.vue?vue&type=template&id=0a569558"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render

export default script